module.exports = __webpack_public_path__ + "img/DSC_1963.5d71517b.JPG";